import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.0_@parcel+watcher@2.5.1_@types+node@22.10.5_@upstash+redis@1.34.3_db0@0.3.1_eslint@_e2zaakva2g6xpwnaggqf5en2sy/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.0_@parcel+watcher@2.5.1_@types+node@22.10.5_@upstash+redis@1.34.3_db0@0.3.1_eslint@_e2zaakva2g6xpwnaggqf5en2sy/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}